import store from '../store';

export const configPlugin = {
    install(Vue) {
        Vue.prototype.$config = getConfig;
    }
};

function isLocal() {
    return (store.state.profiles || []).some(v => v === 'local');
}

function isDev() {
    return (store.state.profiles || []).some(v => v === 'dev');
}

// function isDemo() {
//     return (store.state.profiles || []).some(v => v === 'demo');
// }

export const getConfig = {
    showProdName: true,
    enableCouponSelection: true,
    displayCreditPointLayout() {
        return store.state.enableCreditPoint && !store.getters.isFriendCustomer;
    },
    enableCreditPoint() {
        return store.state.enableCreditPoint && !store.getters.isFriendCustomer;
    },
    testingConfig: {
        showTestPayment() {
            return false && isLocal();
        },
        showTestPaymentEnquiry() {
            return false && isLocal();
        },
        showFpsSimulationBtn() {
            return isLocal() || isDev();
        },
        showFpsFailBtn() {
            return isLocal() || isDev();
        },
        isLocal: isLocal,
        isDev: isDev
    }
};
